import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './store/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Api from './common/api';
import { getApplication } from '@/store/actions/application';
import Loading from '@/components/common/loading';
import './App.scss';
import { checkEnv } from '@/utils/env';
import Title from 'antd/es/typography/Title';

const View = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.application);

  useEffect(() => {
    (async () => {
      const { data } = await Api.init();
      dispatch(getApplication(data));
    })();
  }, []);

  if (isLoading)
    return (
      <div className="vh-100 flex justify-center">
        <Loading isLoading />
      </div>
    );
  return <App />;
};

const ErrorConfigPage = ({ errors }) => {
  return (
    <div className="error-config-page">
      <div>
        <Title level={4}>Invalid application configuration</Title>
        <ul>
          {Object.entries(errors).map(([key, value]) =>
            value ? (
              <li>
                {key}: {value}
              </li>
            ) : null,
          )}
        </ul>
      </div>
    </div>
  );
};

async function initProject() {
  const envError = checkEnv();

  ReactDOM.render(
    Object.values(envError).filter((_) => _).length ? (
      <ErrorConfigPage errors={envError} />
    ) : (
      <Provider store={store}>
        <View />
      </Provider>
    ),
    document.getElementById('root'),
  );
}

initProject();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
